import React, { CSSProperties, FC } from 'react';
import { secondary } from 'assets/colors/colors';

interface HyperLinkProps {
  href: string;
  children: React.ReactNode;
  target?: '_blank' | '_self' | '_parent' | '_top';
  rel?: string;
  className?: string;
  style?: CSSProperties;
}

export const HyperLink: FC<HyperLinkProps> = ({
  href,
  children,
  target = '_blank',
  rel,
  className,
  style,
}) => (
  <a
    href={href}
    target={target}
    rel={rel || (target === '_blank' ? 'noopener noreferrer' : undefined)}
    className={className}
    style={{
      color: secondary.main,
      ...style,
    }}
  >
    {children}
  </a>
);
